import Signal from "libs/signals";

const $globalSearchResults = Signal({
  searchResults: [],
  query: '',
  isLoading: false,
});

export default $globalSearchResults;
